// ══════════════════════════════════════════════════════════════════════════════
//  src/exercises/retosSuperados.js
//  QUÉ RETOS DE ESTE TEMA YA SE GANARON
//
//  Rob, 23-09-2026, sobre el cierre de la lección: «recuerda que todo es de
//  progreso para dominar el tema… poner reto superado y marcarlo en su
//  recuadro».
//
//  Los tres formatos —Fundamentos, Práctica Rápida, Fluidez Total— no son tres
//  opciones sueltas: son tres formas de exigir el MISMO tema, y hacerlas todas
//  es lo que significa dominarlo. Para que eso se vea, hay que recordar cuáles
//  lleva ganadas en esta lección.
//
//  ── POR QUÉ EN EL NAVEGADOR Y NO EN EL SERVIDOR ─────────────────────────────
//  Porque es una ayuda visual, no una nota. El progreso de verdad —que la
//  lección esté completada— ya lo guarda el backend cuando Spacy da la clase
//  por terminada. Esto sólo decide si una tarjeta lleva la chapa «SUPERADO».
//  Si alguien cambia de navegador, lo peor que pasa es que no vea las chapas;
//  nada se pierde ni se cobra dos veces.
//
//  Si algún día se quiere que viaje con el alumno, el sitio es el progreso del
//  curso, y esta función es el único punto que habría que cambiar.
// ══════════════════════════════════════════════════════════════════════════════

const clave = (lessonId) => `spacy_retos_${String(lessonId)}`;

/** Los formatos ya superados en esta lección. Siempre una lista. */
export function retosDe(lessonId) {
    try {
        const crudo = localStorage.getItem(clave(lessonId));
        const lista = crudo ? JSON.parse(crudo) : [];
        return Array.isArray(lista) ? lista : [];
    } catch {
        // Modo privado, almacenamiento lleno o un JSON corrupto de otra versión:
        // ninguna de las tres es motivo para romper el cierre de una clase.
        return [];
    }
}

/** Apunta un reto ganado. Repetirlo no lo duplica. */
export function apuntaReto(lessonId, formato) {
    if (!formato) return retosDe(lessonId);
    const lista = retosDe(lessonId);
    if (lista.indexOf(formato) === -1) lista.push(formato);
    try {
        localStorage.setItem(clave(lessonId), JSON.stringify(lista));
    } catch { /* ver arriba */ }
    return lista;
}

// El orden del camino. `master` no está aquí a propósito: aparece como sorpresa
// cuando los tres están ganados, y un peldaño que no sabías que existía vale
// más que uno anunciado.
export const CAMINO = [
    {
        id: 'fundamentals',
        nombre: 'Fundamentos',
        descripcion: 'Reglas claras y corrección detallada.',
        promesa: 'Las reglas del tema, una a una, corrigiendo cada frase.',
    },
    {
        id: 'practice',
        nombre: 'Práctica Rápida',
        descripcion: 'Minijuegos y diagnóstico veloz.',
        promesa: 'Lo mismo, pero contrarreloj y sin explicaciones largas.',
    },
    {
        id: 'fluency',
        nombre: 'Fluidez Total',
        descripcion: 'Conversación inmersiva sin pausas.',
        promesa: 'Una conversación de verdad, sin pausas y sin red.',
    },
];

/** El siguiente reto que le toca, o `null` si ya los ganó todos. */
export function siguienteReto(lessonId, formatoActual) {
    const ganados = retosDe(lessonId).concat(formatoActual ? [formatoActual] : []);
    return CAMINO.find(r => ganados.indexOf(r.id) === -1) || null;
}
